import { PropsWithChildren } from 'react';

import * as layoutStyles from './FullScreenLayout.styles';
import { AppContextProvider } from '../../context/app/AppContext';

function FullScreenLayout({ children }: PropsWithChildren<unknown>) {
  const { classes } = layoutStyles.useLayoutStyles();

  return (
    <AppContextProvider>
      <div className={classes.root}>
        <main className={classes.main}>
          <div className={classes.content}>{children}</div>
        </main>
      </div>
    </AppContextProvider>
  );
}

export default FullScreenLayout;
